import { Skeleton } from 'antd';

export function TableSkeleton() {
    return (
        <div className="p-4">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 space-y-2 sm:space-y-0">
                <Skeleton.Input
                    className="rounded-lg"
                    style={{ width: 150, height: 24 }}
                    active
                />
                <Skeleton.Input
                    className="rounded-lg"
                    style={{ width: 256, height: 32 }}
                    active
                />
            </div>

            <Skeleton className="rounded-lg" active paragraph={{ rows: 5 }} />
        </div>
    );
}
